module.exports = __webpack_public_path__ + "static/st-clair-logo-c7f6bf0bf30118478045845c75fdd21a.png";